<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>PO管理</el-breadcrumb-item>
        <el-breadcrumb-item>PO时效</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="建单时间">
                <el-date-picker
                  v-model="searchForm.createTime"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单类型">
                <el-select clearable v-model="searchForm.order_level" placeholder="请选择">
                  <el-option
                    v-for="item in ticketTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="PO确认单">
                <el-input v-model="searchForm.opTicketid" placeholder="请输入PO确认单"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="PO标题">
                <el-input v-model="searchForm.serviceInfo" placeholder="请输入PO标题"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="区域园区">
                <el-select clearable v-model="searchForm.campusName" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option
                    v-for="(item, index) in campusOptions"
                    :key="index"
                    :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单等级">
                <el-select clearable v-model="searchForm.ticketLevel" placeholder="请选择">
                  <el-option label="一级" value="1"></el-option>
                  <el-option label="二级" value="2"></el-option>
                  <el-option label="三级" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单状态">
                <el-select clearable v-model="searchForm.order_status" placeholder="请选择">
                  <el-option label="已派单" value="已派单"></el-option>
                  <el-option label="待派单" value="待派单"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">PO时效列表</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <div>
            <el-button
              @click="
                () => {
                  searchForm.expiration_info = 1;
                  handleSearch();
                }
              "
              type="warning"
              >预超时({{ preTimeoutCount }})
            </el-button>
            <el-button
              @click="
                () => {
                  searchForm.expiration_info = 2;
                  handleSearch();
                }
              "
              type="danger"
              >已超时({{ timeoutCount }})
            </el-button>
          </div>
          <div>
            <el-button @click="openHeaderSettings">表头设置</el-button>
          </div>
        </div>
        <el-table
          :data="faults"
          border
          stripe
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            v-for="col in visibleColumns"
            :key="col.prop"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
            :min-width="col.minWidth"
          >
            <template slot-scope="scope">
              <template v-if="col.prop === 'index'"> {{ scope.$index + 1 }} </template>
              <template v-else-if="col.prop === 'createTime'">
                {{
                  scope.row[col.prop]
                    ? $moment(scope.row[col.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-'
                }}
              </template>
              <template v-else-if="col.prop === 'campusName'">{{
                scope.row.campusName === '张家口-怀来东园'
                  ? '怀来-东园'
                  : scope.row[col.prop] || '-'
              }}</template>
              <template v-else-if="col.prop === 'SlALevel'">
                {{
                  scope.row[col.prop] === '1'
                    ? '一级'
                    : scope.row[col.prop] === '2'
                    ? '二级'
                    : scope.row[col.prop] === '3'
                    ? '三级'
                    : scope.row[col.prop] || '-'
                }}
              </template>
              <template v-else-if="col.prop === 'opTicketid'">
                <a
                  :href="
                    scope.row.order_status === '待派单' || scope.row.order_status === '已派单'
                      ? `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                      : `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}`
                  "
                  target="_blank"
                  >{{ scope.row.opTicketid }}</a
                >
              </template>
              <template v-else-if="col.prop === 'po_status'">
                <el-tag
                  :type="scope.row[col.prop] === '已确认' ? 'success' : scope.row[col.prop] === '待确认' ? 'warning' : 'info'"
                  size="small"
                >
                  {{ scope.row[col.prop] || '-' }}
                </el-tag>
              </template>
              <template v-else-if="col.prop === 'order_status'">
                <el-tag
                  :type="scope.row[col.prop] === '已派单' ? 'success' : scope.row[col.prop] === '待派单' ? 'warning' : 'info'"
                  size="small"
                >
                  {{ scope.row[col.prop] || '-' }}
                </el-tag>
              </template>
              <template v-else-if="col.prop === 'feedback_status'">
                <el-tag
                  :type="scope.row[col.prop] === '正常' ? 'success' : scope.row[col.prop] === '预超时' ? 'warning' : scope.row[col.prop] === '已超时' ? 'danger' : 'info'"
                  size="small"
                >
                  {{ scope.row[col.prop] || '-' }}
                </el-tag>
              </template>
              <template v-else>
                {{ scope.row[col.prop] || '-' }}
              </template>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>

    <!-- 表头设置对话框 -->
    <el-dialog
      title="设置显示项"
      :visible.sync="headerSettingsVisible"
      :append-to-body="true"
      width="400px"
      :close-on-click-modal="false"
      custom-class="columns-dialog"
      :modal-append-to-body="false"
      :destroy-on-close="true"
    >
      <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
        <el-checkbox
          v-for="col in allColumns"
          :key="col.prop"
          :label="col.prop"
          class="checkbox-item"
        >
          {{ col.label }}
        </el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleSelectAll">全选</el-button>
        <el-button size="small" @click="restoreDefaults">恢复默认</el-button>
        <el-button size="small" type="primary" @click="saveHeaderSettings">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getExpirationCount,
  poExpirationList,
  getExpirationListAll,
  expirationInfoList,
} from '@/api/appManage';

import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import { getCampusList } from '@/api/operation'
export default {
  name: 'FaultList',
  data() {
    return {
      headerSettingsVisible: false,
      selectAll: false,
      selectedColumns: [],
      selectedRows: [],
      exportLoading: false,
      loading: false,
      preTimeoutCount: 0,
      timeoutCount: 0,
      allColumns: [
        { prop: 'opTicketid', label: 'PO确认单', width: '130' },
        { prop: 'serviceInfo', label: 'PO标题', minWidth: '170' },
        { prop: 'order_level', label: '工单类型', width: '80' },
        { prop: 'campusName', label: '区域园区', width: '90' },
        { prop: 'process_user', label: '负责人', width: '100' },
        { prop: 'createTime', label: '建单时间', width: '150' },
        { prop: 'sla_time', label: '响应与分派SLA', width: '150' },
        // {
        //   prop: 'SlALevel',
        //   label: '工单等级',
        //   width: '70',
        //   template: function (row) {
        //     const levelMap = {
        //       1: '一级',
        //       2: '二级',
        //       3: '三级',
        //     };
        //     return levelMap[row.SlALevel] || row.SlALevel;
        //   },
        // },
        { prop: 'po_status', label: 'PO状态', width: '80' },
        { prop: 'order_status', label: '工单状态', width: '80' },
        { prop: 'feedback_status', label: '超时状态', width: '80' },
        { prop: 'pre_timeout_time', label: '预超时时长(分钟)', width: '120' },
        { prop: 'timeout_time', label: '超时时长(分钟)', width: '120' },
      ],
      faults: [],
      searchForm: {
        createTime: '',
        ticketType: '',
        ticketLevel: '',
        order_status: '',
        serviceInfo: '',
        opTicketid: '',
        campusName: '',
        order_level: '',
        expiration_info: 3,
      },
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      ticketTypeOptions: [
        { value: '1', label: '服务器' },
        { value: '2', label: '网络' },
        { value: '3', label: '资产' },
        { value: '4', label: '其它' },
        { value: '5', label: '人力' },
      ],
      regionOptions: [
        { value: 'sh-lg', label: '上海-临港' },
        { value: 'sh-sy', label: '上海-书院' },
        { value: 'hz-dg', label: '杭州-东冠' },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  computed: {
    visibleColumns() {
      return this.allColumns.filter((col) => this.selectedColumns.includes(col.prop));
    },
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  created() {
    // 初始化时默认显示所有列
    this.selectedColumns = this.allColumns.map((col) => col.prop);
    // 设置默认日期范围为最近一个月
     const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.createTime = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    // 获取超时统计数据
    this.fetchExpirationCount();
    this.getPoExpirationList();
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    //园区获取数据接口
    async getCampusData() {  
      try {
        const params = {
          spec_sign: 0,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data; 
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    async fetchExpirationCount() {
      try {
        const response = await getExpirationCount();
        if (response.data) {
          this.preTimeoutCount = response.data.data.list[0].pre_timeout_count;
          this.timeoutCount = response.data.data.list[0].timeout_count;
        }
      } catch (error) {
        console.error('获取超时统计数据失败:', error);
        this.$message.error('获取超时统计数据失败');
      }
    },
    openHeaderSettings() {
      this.headerSettingsVisible = true;
      this.selectAll = this.selectedColumns.length === this.allColumns.length;
    },
    handleSelectAll(val) {
      this.selectedColumns = val ? this.allColumns.map((col) => col.prop) : [];
    },
    restoreDefaults() {
      this.selectedColumns = this.allColumns.map((col) => col.prop);
      this.selectAll = true;
    },
    saveHeaderSettings() {
      this.headerSettingsVisible = false;
    },
    async getPoExpirationList() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
      };

      // 处理日期范围
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        params.start_time = this.searchForm.createTime[0];
        params.end_time = this.searchForm.createTime[1] + ' 23:59:59';
      }

      // 映射其他查询参数
      if (this.searchForm.order_level) params.order_level = this.searchForm.order_level;
      if (this.searchForm.ticketLevel) params.SlALevel = this.searchForm.ticketLevel;
      if (this.searchForm.expiration_info) params.expiration_info = this.searchForm.expiration_info;
      if (this.searchForm.order_status) params.order_status = this.searchForm.order_status;
      if (this.searchForm.serviceInfo) params.serviceInfo = this.searchForm.serviceInfo;
      if (this.searchForm.opTicketid) params.opTicketid = this.searchForm.opTicketid;
      if (this.searchForm.campusName) params.campusName = this.searchForm.campusName;

      this.loading = true;

      try {
        const response = await poExpirationList(params);
        if (response.data && response.data.data) {
          this.faults = response.data.data.list || [];
          this.total = response.data.data.total || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.getPoExpirationList();
    },
    handleReset() {
      this.searchForm = {
        createTime: '',
        ticketType: '',
        ticketLevel: '',
        order_status: '',
        serviceInfo: '',
        opTicketid: '',
        campusName: '',
        order_level: '',
        expiration_info: 3,
      };
      this.currentPage = 1;
      this.getPoExpirationList();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    async handleExport() {
      if (this.exportLoading) return;
      try {
        this.exportLoading = true;
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const response = await getExpirationListAll({
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([_, value]) => value !== '' && value !== null && value !== undefined
              )
            ),
          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.list || [];
            // 转换数据格式
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                let value = row[column.prop];
                // 特殊字段处理
                if (column.prop === 'createTime') {
                  value = row[column.prop]
                    ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-';
                }
                rowData[column.label] = value || '-';
              });
              return rowData;
            });

            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'PO时效');

            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `PO时效_${timestamp}.xlsx`;

            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              let value = row[column.prop];
              if (column.prop === 'createTime') {
                value = row[column.prop]
                  ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                  : '-';
              }
              rowData[column.label] = value || '-';
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'PO实效');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `PO实效_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPoExpirationList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPoExpirationList();
    },
    handleIndexClick(row) {
      // 处理序号点击事件，可以根据需求进行相应的操作
    },
    handleDateChange() {
      this.getPoExpirationList();
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button + .el-button {
  margin-left: 8px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: calc(100% - 10px) !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: calc(110% - 10px) !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: calc(110% - 10px) !important;
}
::v-deep .el-form-item__content {
  width: calc(110% - 10px) !important;
}
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
</style>